<template>
  <vs-row w-full>
    <vs-col :lg="3" :sm="12">
      <div class="text-primary-light mt-4">
        Hi {{ userInfo.clientData && userInfo.clientData.displayName }},
      </div>
      <h1>Welcome to Selfcare</h1>
      <div class="info-card">
        <img src="@/assets/icons/dashboard-card-1.svg" alt="" />
        <div class="info">
          <div class="text-primary-lighter">
            Customer ID:
            {{ userInfo.clientData && userInfo.clientData.accountNo }}
          </div>
          <div>
            <b
              >Balance:
              {{ userInfo.clientData && userInfo.clientData.balanceAmount }}</b
            >
          </div>
          <div class="text-primary-lighter">
            Status:
            <span class="vs-success">{{
              userInfo.clientData && userInfo.clientData.status.value
            }}</span>
          </div>
        </div>
      </div>
      <div class="info-card">
        <img src="@/assets/icons/dashboard-card-2.svg" alt="" />
        <div class="info">
          <div class="text-primary-lighter ">
            Meter ID:
            {{ userInfo.clientData && userInfo.clientData.hwSerialNumber }}
          </div>
          <div>
            <b
              >Plan Name:
              {{
                userInfo.clientOrdersData &&
                  userInfo.clientOrdersData[0].planDescription
              }}</b
            >
          </div>
          <div class="text-primary-lighter">
            Start Date:
            <span
              :data="
                getDate(
                  userInfo.clientOrdersData &&
                    userInfo.clientOrdersData[0].startDate | dateFormat
                )
              "
              class="vs-success"
              >{{
                getDate(
                  userInfo.clientOrdersData &&
                    userInfo.clientOrdersData[0].startDate | dateFormat
                )
              }}</span
            >
            <!-- <vs-td :data="getDate(good.purchaseDate)">{{
                          getDate(good.purchaseDate)
                        }}</vs-td> -->
          </div>
        </div>
      </div>
      <div class="info-card">
        <img src="@/assets/icons/dashboard-card-2.svg" alt="" />
        <div class="info">
          <div class="text-primary-lighter">
            Next Bill Date:
            <span
              :data="
                getDate(
                  userInfo.clientOrdersData &&
                    userInfo.clientOrdersData[0].invoiceTilldate
                )
              "
            >
              {{
                getDate(
                  userInfo.clientOrdersData &&
                    userInfo.clientOrdersData[0].invoiceTilldate
                )
              }}
            </span>
          </div>
          <div>
            <b
              >Current Charges:
              {{
                userInfo.clientOrdersData && userInfo.clientOrdersData[0].price
              }}</b
            >
          </div>
          <div class="text-primary-lighter">
            Pending Due:
            <span class="vs-success">{{
              userInfo.clientData && userInfo.clientData.balanceAmount
            }}</span>
          </div>
        </div>
      </div>
    </vs-col>
    <vs-col :lg="9" :sm="12">
      <div class="text-primary-light mt-4">&nbsp;</div>
      <div class="dropdown">
        <h1 class="ml-4">Monthly Bill Trend</h1>
        <v-select
          label="text"
          :reduce="obj => obj.value"
          placeholder="Select Year"
          :options="trendOptions"
          v-model="selectedYear"
          :clearable="false"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-200"
        />
      </div>
      <div class="chart-container">
        <h6 class="selected-text">Selected Year : {{ selectedYearName }}</h6>
        <vue-apex-charts
          type="bar"
          height="300px"
          :options="monthlyBillTrendOptions"
          :series="monthlyBillTrendData"
        ></vue-apex-charts>
      </div>
    </vs-col>
    <div class="dropdown mt-6">
      <h1 class="ml-4">Consumption Vs Charge</h1>
      <v-select
        label="text"
        :reduce="obj => obj.value"
        placeholder="Select Month"
        :options="usageOptions"
        v-model="selectedMonth"
        :clearable="false"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
        class="w-200"
      />
    </div>
    <vs-col :lg="12">
      <div class="chart-container">
        <h6 class="selected-text">Selected Month : {{ selectedMonthName }}</h6>
        <vue-apex-charts
          type="bar"
          height="300px"
          :options="dailyUsageOptions"
          :series="dailyUsageData"
        ></vue-apex-charts></div
    ></vs-col>
  </vs-row>
</template>
<script>
import ApexCharts from "apexcharts";
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import vSelect from "vue-select";
import moment from "moment";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const options1 = {
  colors: ["#2B3674", "#B5FAFF"],
  chart: {
    id: "vuechart-example",
    stacked: true
  },
  xaxis: {
    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
  },
  yaxis: {
    logarithmic: false
  },
  dataLabels: {
    enabled: false
  },
  plotOptions: {
    bar: {
      columnWidth: "20%",
      dataLabels: {
        position: "top",
        enabledOnSeries: [1]
      }
    },
    dataLabels: {
      enabled: false,
      style: {
        colors: ["#333"]
      },
      offsetX: 30
    }
  }
};
const options2 = {
  colors: ["#2B3674", "#B5FAFF"],
  chart: {
    id: "vuechart-example",
    stacked: true
  },
  xaxis: {
    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
  },
  yaxis: {
    logarithmic: false
  },
  dataLabels: {
    enabled: false
  },
  plotOptions: {
    bar: {
      columnWidth: "20%",
      dataLabels: {
        position: "top",
        enabledOnSeries: [1]
      }
    },
    dataLabels: {
      enabled: false,
      style: {
        colors: ["#333"]
      },
      offsetX: 30
    }
  }
};
export default {
  data() {
    return {
      usageOptions: [{ text: "Current Month", value: 0 }],
      selectedMonth: 1,
      trendOptions: [{ text: "Current Year", value: 0 }],
      selectedYear: 0
    };
  },
  components: {
    VueApexCharts,
    "v-select": vSelect
  },
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    isLogin() {
      return this.$store.getters["auth/isLogin"];
    },
    // ...mapState({
    //   billData: (state) => state.dashbaord.billData,
    // }),
    billData() {
      return this.$store.getters["dashboard/getBillData"];
    },
    getDailyUsage() {
      return this.$store.getters["dashboard/getDailyUsage"];
    },
    monthlyBillTrendData() {
      if (!this.billData.data) return [];
      return [
        {
          name: "Bill",
          data: [...this.billData.data.map(el => el && el.row && el.row[4])]
        }
      ];
    },
    monthlyBillTrendOptions() {
      const option = {
        ...options1
      };
      if (!this.billData.data) return option;
      const labels = this.billData.data.map(el => el && el.row && el.row[5]);
      option.xaxis.categories = [];
      for (const el of labels) {
        option.xaxis.categories.push(months[el - 1]);
      }
      return option;
    },
    dailyUsageData() {
      if (!this.getDailyUsage.data) return [];
      return [
        {
          name: "unit",
          data: [
            ...this.getDailyUsage.data.map(el => el && el.row && el.row[1])
          ]
        },
        {
          name: "charge",
          data: [
            ...this.getDailyUsage.data.map(el => el && el.row && el.row[2])
          ]
        }
      ];
    },
    dailyUsageOptions() {
      const option = {
        ...options2
      };
      if (!this.getDailyUsage.data) return option;

      const labels = this.getDailyUsage.data.map(
        el => el && el.row && el.row[3]
      );

      option.xaxis.categories = [];

      for (const el of labels) {
        option.xaxis.categories.push(moment(el).format("DD"));
      }
      return option;
    },
    selectedMonthName() {
      this.getDailyUsageFunc();
      return moment()
        .subtract(this.selectedMonth, "month")
        .format("MMMM YYYY");
    },
    selectedYearName() {
      this.getClientChartData();
      return moment()
        .subtract(this.selectedYear, "year")
        .format("YYYY");
    }
  },
  methods: {
    getDate(date) {
      return moment().format("DD MMMM YYYY");
    },
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$store
        .dispatch("auth/logout")
        .then(resp => this.$router.push("/login"));
    },
    async getClientChartData() {
      try {
        await this.$store.dispatch("dashboard/getBillTrend", {
          slNo: this.userInfo.clientData.hwSerialNumber,
          year: moment()
            .subtract(this.selectedYear, "year")
            .format("YYYY")
        });
      } catch (e) {}
    },
    async getDailyUsageFunc() {
      try {
        const payload = {
          slNo: this.userInfo.clientData.hwSerialNumber,
          startDate: moment()
            .subtract(this.selectedMonth, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment()
            .subtract(this.selectedMonth, "month")
            .endOf("month")
            .format("YYYY-MM-DD")
        };
        await this.$store.dispatch("dashboard/getDailyUsage", payload);
      } catch (e) {}
    },
    filters: {
      dateFormat: function(value) {
        if (!value) return "";

        return moment(value)
          .subtract(1, "month")
          .format("DD-MM-YYYY");
      }
    }
  },
  mounted() {
    if (!this.isLogin) this.$router.push("/login");
    console.log("hi", this.userInfo);
    for (let i = 1; i <= 12; i++)
      this.usageOptions.push({
        text: moment()
          .subtract(i, "month")
          .format("MMMM"),
        value: i
      });
    for (let i = 1; i <= 5; i++)
      this.trendOptions.push({
        text: moment()
          .subtract(i, "year")
          .format("YYYY"),
        value: i
      });

    this.getClientChartData();
    this.getDailyUsageFunc();
  }
};
</script>
<style lang="scss">
.apexcharts-canvas {
  background: #fff;

  //   padding: 2rem 1rem;
}
.apexcharts-menu-icon {
  display: none;
}
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
}
.dropdown {
  display: flex;
  width: calc(100% - 20px);
  justify-content: space-between;
}
.selected-text {
  margin-left: 20px;
}
.info {
  margin-left: 10px;
}
.w-200 {
  max-width: 200px;
}
h6 {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
